import React from "react";
import ReactMarkdown from "react-markdown";

// Full-page view for a single post. Replaces the feed when a user clicks "Read more".
export default function PostView({ post, onBack, isAdmin, onDelete }) {
  return (
    <div className="page">
      <header className="site-header">
        <div className="header-inner">
          <button className="back-btn" onClick={onBack}>
            ← Back
          </button>
          <span className="site-title">Evan Zone</span>
          {isAdmin && (
            <button className="delete-btn-header" onClick={onDelete}>
              Delete
            </button>
          )}
        </div>
      </header>

      <main className="post-main">
        <article className="post-full">
          <div className="post-full-meta">
            <span className="feed-author">{post.author}</span>
            <span className="meta-dot">·</span>
            <span className="feed-date">{post.date}</span>
          </div>
          {post.title && <h1 className="post-full-title">{post.title}</h1>}
          <div className="post-body">
            <ReactMarkdown>{post.content}</ReactMarkdown>
          </div>
        </article>

        <div className="post-nav">
          <button className="back-btn-bottom" onClick={onBack}>
            ← Back to feed
          </button>
        </div>
      </main>

      <footer className="site-footer">
        <span>© {new Date().getFullYear()} Evan Zone</span>
      </footer>
    </div>
  );
}
